import { apiRequest } from '../client'

export interface WebbillSyncConfig {
  configured: boolean
  enabled?: boolean
  baseUrl?: string
  clientId?: string
  idsToken?: string
  datasheetToken?: string
  cronExpression?: string
  newProductsActive?: boolean
  deactivateRemoved?: boolean
  includeImages?: boolean
  batchSize?: number
  batchDelayMs?: number
  requestDelayMs?: number
  defaultCategoryCode?: string | null
  lastSyncAt?: string
}

export interface WebbillSyncConfigRequest {
  enabled: boolean
  baseUrl: string
  clientId: string
  idsToken: string
  datasheetToken: string
  cronExpression: string
  newProductsActive: boolean
  deactivateRemoved: boolean
  includeImages: boolean
  batchSize: number
  batchDelayMs: number
  requestDelayMs: number
  defaultCategoryCode: string | null
}

export interface WebbillSyncHistoryItem {
  id: number
  triggerType: string
  status: string
  startedAt: string
  finishedAt?: string
  totalIds?: number
  createdCount: number
  updatedCount: number
  skippedCount: number
  deactivatedCount: number
  errorCount: number
  errorsJson?: string
}

export interface WebbillSyncResult {
  ok: boolean
  totalIds?: number
  created: number
  updated: number
  skipped: number
  deactivated: number
  errorCount: number
  errors?: Array<string>
}

export const webbillSyncApi = {
  getConfig: () =>
    apiRequest<WebbillSyncConfig>('/api/v0/admin/webbill-sync/config'),

  saveConfig: (data: WebbillSyncConfigRequest) =>
    apiRequest<{ ok: boolean }>('/api/v0/admin/webbill-sync/config', {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  triggerSync: () =>
    apiRequest<WebbillSyncResult>('/api/v0/admin/webbill-sync/trigger', {
      method: 'POST',
    }),

  getHistory: (limit = 20) =>
    apiRequest<{ items: Array<WebbillSyncHistoryItem> }>(
      `/api/v0/admin/webbill-sync/history?limit=${limit}`,
    ),
}
